import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KpiLogicService {
    private readonly _http = inject(HttpClient);
    private readonly apiLink = environment.apiLink;

    /** DELETE /v1/kpi-logic/delete-kpi/{kpiId} */
    deleteKpi(kpiId: number | string): Observable<unknown> {
        const id = encodeURIComponent(String(kpiId));
        return this._http.delete(`${this.apiLink}kpi-logic/delete-kpi/${id}`);
    }

    /** PUT /v1/kpi-logic/set-kpi-lock */
    setKpiLock(kpiId: number, locked: boolean): Observable<unknown> {
        return this._http.put(`${this.apiLink}kpi-logic/set-kpi-lock`, {
            kpi_id: kpiId,
            locked,
        });
    }

    /** POST /v1/kpi-logic/import-kpis/{tableId}?isExternal=... */
    importKpis(
        tableId: number | string,
        isExternal: boolean,
        file: File
    ): Observable<unknown> {
        const id = encodeURIComponent(String(tableId));
        const formData = new FormData();
        formData.append('file', file);

        return this._http.post(`${this.apiLink}kpi-logic/import-kpis/${id}`, formData, {
            params: { isExternal: String(isExternal) },
        });
    }
}
